import React, {Component} from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip'
import Registry from 'registry';

import ModalMyBobTVRoom from 'components/modals/ModalMyBobTVRoom';
import ToggleButton from 'components/ToggleButton';
import PenIcon from "components/icon/Pen"

import {t, dt} from 'l10n';

import 'sass/room.scss';

import {activateMemberPersonalRoom, deactivateMemberPersonalRoom} from 'backend-helpers/memberPersonalRooms';

import {memberPersonalRoomActivated, memberPersonalRoomDeactivated} from 'reducers/member';

import {PERSONAL_ROOM_USER_LIMIT} from 'constants/mybobtv';

class MyBobTV extends Component{
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            modalAction: 'create',
            room_active: false
        };

        this.onOpenRoomClick = this.onOpenRoomClick.bind(this);
        this.onCloseRoomClick = this.onCloseRoomClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let {room} = nextProps;

        if(room) this.setState({room_active: !!room.active});
    }

    openRoomPage(room) {
        return window.open(room.url, 'chat', 'height=678,width=1200,resizable=1,toolbar=0,scrollbars=0');
    }

    onOpenRoomClick(event) {
        event.preventDefault();

        let {room, memberPersonalRoomActivated, currentUser} = this.props;
        let {room_active} = this.state;

        if(!currentUser || !currentUser.isXXL()) {
            this.setState({showModal: true, modalAction: 'open'});
            return;
        }
        
        if (!room_active) {
            let _window = this.openRoomPage(room);

            activateMemberPersonalRoom(room.roomid)
                .then(() => {
                    memberPersonalRoomActivated(room.roomid);
                    _window.location = room.url;
                    this.setState({room_active: true});
                })
                .catch((error) => {
                    console.log('MyBobTV activateMemberPersonalRoom error', error);
                    _window.close();
                    this.setState({showModal: true});
                });
        } else {
            this.openRoomPage(room);
        }
    }

    onCloseRoomClick(event) {
        event.preventDefault();

        let {room} = this.props;
        let {room_active} = this.state;

        if (room_active) {

            deactivateMemberPersonalRoom(room.roomid)
                .then(() => {
                    memberPersonalRoomDeactivated(room.roomid);
                    this.setState({room_active: false});
                })
                .catch((error) => {
                    this.setState({showModal: true, modalAction: 'error', error: error.message})
                });
        }
    }

    getInfoTooltip(t) {
        return (Registry.get('ENVIRONMENT', false) !== 'server') ? (
            <ReactTooltip id={'tooltip-mybobtv'} type="light" className="tooltip tooltip-room">
                <p className="name">My BobTV</p>
                <p>{t("My BobTV is a platform of free chat rooms available to BobTV subscribers. The creator of each room is the moderator, he is free to manage his own room within in accordance with BobTV's CGU. The themes are varied, such as: blind-test, games, conversations between friends, sexy or soft shows, hard dialogues and crude words ... The creator chooses the theme of his chat room, he welcomes his friends and provides a friendly atmosphere.")}</p>
                <p dangerouslySetInnerHTML={{__html: t('Per room limit: <strong>%1</strong> users', PERSONAL_ROOM_USER_LIMIT)}}></p>
            </ReactTooltip>
        ) : null;
    }

    render() {
        let {room, returnPath} = this.props;
        let {room_active} = this.state;

        return (
            <div className="room-item my stub">
                {this.getInfoTooltip(t)}

                <div className="content">
                    <div className="top">
                        <div className="left-top">
                            <div className="left-top-inner">
                                <span className="title-prefix">My</span>
                                <span className="line"> | </span>
                                <span className="room-name">BobTV</span>
                                <i className="icon-info" data-tip='' data-for={'tooltip-mybobtv'}></i>
                            </div>
                        </div>

                        <div className="right-top control-room">
                            {room && <div className="edit-room" title={ dt('mybobtv', 'Edit your room') } onClick={() => this.setState({showModal: true, modalAction: 'edit'})}><PenIcon colorIndex="theme" hoverColorIndex="white"/></div>}

                            {!room && <div className="create-room" onClick={() => {
                                if (!this.state.showModal) {
                                    this.setState({showModal: true, modalAction: 'create'})
                                } else {
                                    this.setState({showModal: false, modalAction: ''})
                                    setTimeout(() => this.setState({showModal: true, modalAction: 'create'}), 100)
                                }
                            }}>{dt('mybobtv', 'Create my room')}</div>}
                            <ModalMyBobTVRoom
                                error={this.state.error}
                                show={this.state.showModal}
                                action={this.state.modalAction}
                                closeFn={() => this.setState({showModal: false})}
                                room={room}
                                returnPath={returnPath}
                            />
                            {room && <ToggleButton active={room_active} onToggleOn={this.onOpenRoomClick} onToggleOff={this.onCloseRoomClick} titleWhenOn={dt('mybobtv', 'Slide to close')} titleWhenOff={dt('mybobtv', 'Slide to open')}/>}
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        room: state.member ? state.member.personalRoom : null,
    }),
    {
        memberPersonalRoomActivated: memberPersonalRoomActivated,
        memberPersonalRoomDeactivated: memberPersonalRoomDeactivated,
    }
)(MyBobTV);


// WEBPACK FOOTER //
// ./src/components/index/MyBobTV.js